// FILE: src/components/layout/AppLayout.js (Disempurnakan dengan Menu Dropdown)

import React, { useState, useContext, Fragment, useEffect } from 'react';
import { AuthContext, AppStateContext } from '../../App';
import { Menu, Transition } from '@headlessui/react'; // <-- Impor baru
import { 
    Home, Calendar, ClipboardCheck, BookText, GraduationCap, Users, 
    Milestone, FileText, Settings, HelpCircle, Menu as MenuIcon, X, LogOut, BookOpen, CreditCard, Bell, User, Grid, MinusSquare, Image, CalendarCheck, MessageSquare, LayoutDashboard, CheckSquare, CalendarDays, NotebookPen, Medal, FileImage, Users2, CalendarCheck2, FileBarChart2, CalendarRange, Award
} from 'lucide-react';
import { Outlet } from 'react-router-dom';

const NavItem = ({ icon: Icon, text, active, onClick }) => (
    <button
        onClick={onClick}
        className={`w-full flex items-center p-3 rounded-lg transition-colors duration-200 ${
            active ? 'bg-white/20 text-white' : 'text-gray-300 hover:bg-white/10 hover:text-white'
        }`}
    >
        <Icon className="h-5 w-5 mr-3 flex-shrink-0" />
        <span className="text-sm font-medium">{text}</span>
    </button>
);

// Tambahkan komponen MobileNavbar
const MobileNavbar = ({ currentPage, navigate }) => {
  const navs = [
    { id: 'dashboard', label: 'Home', icon: Home },
    { id: 'absensi', label: 'Absensi', icon: CheckSquare },
    { id: 'menu', label: 'Menu', icon: MenuIcon },
    { id: 'laporan', label: 'Laporan', icon: FileText },
    { id: 'pengaturan', label: 'Pengaturan', icon: Settings },
  ];
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 flex justify-center items-center px-2 py-1 shadow-2xl md:hidden">
      <div className="flex w-full max-w-md mx-auto justify-between">
        {navs.map((nav) => {
          const active = currentPage === nav.id;
          return (
            <button
              key={nav.id}
              onClick={() => navigate(nav.id)}
              className="flex flex-col items-center flex-1 py-2 focus:outline-none"
            >
              <div className={`flex items-center justify-center w-10 h-10 rounded-full transition-all duration-200 ${active ? 'bg-[#7963F5] text-white shadow-lg' : 'text-gray-400 group-hover:text-[#7963F5]'}`}
              >
                <nav.icon className={`w-6 h-6 ${active ? 'text-white' : 'text-gray-400'}`} />
              </div>
              <span className={`text-xs mt-1 font-medium transition-all duration-200 ${active ? 'text-[#7963F5]' : 'text-gray-500'}`}>{nav.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

// Tambahkan komponen MobileMenuOverlay
const mobilePages = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, color: 'bg-green-400', iconColor: 'text-white' },
  { id: 'absensi', label: 'Absensi', icon: CheckSquare, color: 'bg-purple-400', iconColor: 'text-white' },
  { id: 'jadwal', label: 'Jadwal', icon: CalendarDays, color: 'bg-orange-400', iconColor: 'text-white' },
  { id: 'jurnal', label: 'Jurnal', icon: BookOpen, color: 'bg-green-400', iconColor: 'text-white' },
  { id: 'nilai', label: 'Nilai', icon: Award, color: 'bg-yellow-400', iconColor: 'text-white' },
  { id: 'data-siswa', label: 'Siswa', icon: Users, color: 'bg-cyan-400', iconColor: 'text-white' },
  { id: 'agenda', label: 'Agenda', icon: CalendarCheck, color: 'bg-red-400', iconColor: 'text-white' },
  { id: 'laporan', label: 'Laporan', icon: FileText, color: 'bg-cyan-400', iconColor: 'text-white' },
  { id: 'kalender-pendidikan', label: 'Kaldik', icon: Calendar, color: 'bg-purple-400', iconColor: 'text-white' },
  { id: 'bantuan', label: 'Bantuan', icon: HelpCircle, color: 'bg-red-400', iconColor: 'text-white' },
  { id: 'subscribe', label: 'Subscribe', icon: CreditCard, color: 'bg-blue-400', iconColor: 'text-white' },
];

const MobileMenuOverlay = ({ open, onClose, navigate }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-white/95 flex flex-col md:hidden animate-fade-in">
      <div className="flex items-center justify-between p-4 border-b">
        <span className="text-lg font-bold text-gray-800">Menu</span>
        <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100"><X className="h-6 w-6 text-gray-700" /></button>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        <div className="grid grid-cols-3 gap-4">
          {mobilePages.map(page => (
            <button
              key={page.id}
              onClick={() => { onClose(); navigate(page.id); }}
              className="flex flex-col items-center justify-center p-4 rounded-2xl bg-white shadow hover:shadow-md transition group"
            >
              <div className={`mb-2 w-14 h-14 flex items-center justify-center rounded-full ${page.color} shadow-lg group-hover:scale-105 transition`}>
                <page.icon className={`w-7 h-7 ${page.iconColor}`} />
              </div>
              <span className="text-base font-semibold text-gray-800 group-hover:text-[#7963F5] transition text-center">{page.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

const AppLayout = ({ currentPage, navigate, children }) => {
    const { user, logout } = useContext(AuthContext);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [profileDropdown, setProfileDropdown] = useState(false);
    const [desktopMenuOpen, setDesktopMenuOpen] = useState(false);
    const { isAdmin } = useContext(AppStateContext);

    const navItems = [
        { id: 'dashboard', text: 'Dashboard', icon: Home },
        { id: 'jadwal', text: 'Jadwal', icon: Calendar },
        { id: 'absensi', text: 'Absensi', icon: ClipboardCheck },
        { id: 'jurnal', text: 'Jurnal', icon: BookText },
        { id: 'nilai', text: 'Nilai', icon: GraduationCap },
        { id: 'subscribe', text: 'Subscribe', icon: CreditCard },
        { id: 'data-siswa', text: 'Siswa', icon: Users },
        { id: 'agenda', text: 'Agenda', icon: Milestone },
        { id: 'laporan', text: 'Laporan', icon: FileText },
        { id: 'kalender-pendidikan', text: 'Kaldik', icon: Calendar },
    ];
    const bottomNavItems = [{ id: 'bantuan', text: 'Bantuan', icon: HelpCircle }];

    const SidebarContent = () => (
        <div className="flex flex-col h-full text-white">
            <div className="flex items-center justify-center h-20">
                <span className="text-2xl font-bold tracking-wide text-white">LakuKelas</span>
            </div>
            
            <nav className="flex-1 px-3 space-y-2 overflow-y-auto scrollbar-none">
                {isAdmin ? (
                    <button onClick={() => navigate('/admin')} className={`w-full text-left px-4 py-2 rounded ${currentPage === 'admin' ? 'bg-blue-100 dark:bg-blue-900 text-blue-700' : 'hover:bg-gray-100 dark:hover:bg-gray-700'}`}>Admin Panel</button>
                ) : (
                    <ul>{navItems.map(item => (<li key={item.id}><NavItem icon={item.icon} text={item.text} active={currentPage === item.id} onClick={() => { navigate(item.id.startsWith('/') ? item.id : '/' + item.id); setIsSidebarOpen(false); }}/></li>))}</ul>
                )}
            </nav>
            
            <div className="px-3 pb-2">
                <ul>{bottomNavItems.map(item => (<li key={item.id}><NavItem icon={item.icon} text={item.text} active={currentPage === item.id} onClick={() => { navigate(item.id.startsWith('/') ? item.id : '/' + item.id); setIsSidebarOpen(false); }}/></li>))}</ul>
                 
                {/* --- PERUBAHAN UTAMA: Bagian Profil menjadi Menu Dropdown --- */}
                <Menu as="div" className="relative mt-4">
                    <Menu.Button className="w-full p-3 text-left rounded-lg hover:bg-white/10 transition-colors">
                        <div className="flex items-center gap-3">
                            <img 
                                src={user?.photoURL || `https://ui-avatars.com/api/?name=${user?.displayName || 'A'}&background=random&color=fff`} 
                                alt="User Avatar"
                                className="h-10 w-10 rounded-full object-cover"
                            />
                            <div className="flex-1 min-w-0">
                                <p className="text-sm font-semibold truncate">{user?.displayName || 'Nama Pengguna'}</p>
                                <p className="text-xs text-gray-300 truncate">{user?.email || 'email@pengguna.com'}</p>
                            </div>
                        </div>
                    </Menu.Button>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items className="absolute bottom-full left-0 mb-2 w-56 origin-bottom-left rounded-md bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className="py-1">
                                <Menu.Item>
                                    {({ active }) => (
                                        <button onClick={() => { navigate('/pengaturan'); setIsSidebarOpen(false); }} className={`${ active ? 'bg-gray-100 dark:bg-gray-700' : '' } group flex w-full items-center rounded-md px-4 py-2 text-sm text-gray-900 dark:text-gray-200`}>
                                            <Settings className="mr-3 h-5 w-5 text-gray-500 dark:text-gray-400" /> Pengaturan
                                        </button>
                                    )}
                                </Menu.Item>
                                <Menu.Item>
                                    {({ active }) => (
                                        <button onClick={logout} className={`${ active ? 'bg-gray-100 dark:bg-gray-700' : '' } group flex w-full items-center rounded-md px-4 py-2 text-sm text-red-700 dark:text-red-400`}>
                                            <LogOut className="mr-3 h-5 w-5" /> Logout
                                        </button>
                                    )}
                                </Menu.Item>
                            </div>
                        </Menu.Items>
                    </Transition>
                </Menu>
            </div>
        </div>
    );

    useEffect(() => {
        if (mobileMenuOpen) {
            window.history.pushState({ menuOpen: true }, '');
            const onPopState = () => setMobileMenuOpen(false);
            window.addEventListener('popstate', onPopState);
            return () => window.removeEventListener('popstate', onPopState);
        }
    }, [mobileMenuOpen]);

    return (
        <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200">
            {/* Sidebar hanya untuk lg ke atas */}
            <aside className="hidden lg:flex lg:flex-col lg:fixed lg:inset-y-0 lg:left-0 lg:z-40 lg:w-64 lg:bg-gradient-to-b lg:from-[#7963F5] lg:to-[#23213a] lg:text-white lg:shadow-2xl">
                <style>{`
                    .sidebar-scrollbar::-webkit-scrollbar { display: none; }
                    .sidebar-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
                `}</style>
                <div className="flex flex-col h-full">
                    <div className="flex items-center justify-center h-20">
                        <span className="text-2xl font-bold tracking-wide text-white">LakuKelas</span>
                    </div>
                    <nav className="sidebar-scrollbar flex-1 px-3 py-4 space-y-1 overflow-y-auto">
                        {isAdmin ? (
                            <button onClick={() => navigate('/admin')} className={`w-full text-left px-4 py-2 rounded ${currentPage === 'admin' ? 'bg-blue-100 dark:bg-blue-900 text-blue-700' : 'hover:bg-gray-100 dark:hover:bg-gray-700'}`}>Admin Panel</button>
                        ) : (
                            navItems.map(item => (
                                <button
                                    key={item.id}
                                    onClick={() => navigate(item.id.startsWith('/') ? item.id : '/' + item.id)}
                                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 text-left group
                                        ${currentPage === item.id ? 'bg-gradient-to-r from-[#7963F5] to-[#9B8AF8] text-white shadow-lg' : 'hover:bg-[#28264a] text-gray-200 hover:text-white'}
                                    `}
                                    style={{ boxShadow: currentPage === item.id ? '0 2px 12px 0 #7963F533' : undefined }}
                                >
                                    <item.icon className={`h-5 w-5 ${currentPage === item.id ? 'text-white' : 'text-[#b5b3d6] group-hover:text-white'}`} />
                                    <span className="font-medium text-base">{item.text}</span>
                                </button>
                            ))
                        )}
                    </nav>
                    <div className="px-4 py-4 border-t border-[#28264a] bg-transparent">
                        <div className="flex items-center gap-3 mb-2">
                            <img
                                src={user?.photoURL || `https://ui-avatars.com/api/?name=${user?.displayName || 'A'}&background=random&color=fff`}
                                alt="User Avatar"
                                className="h-10 w-10 rounded-full object-cover border-2 border-[#7963F5] bg-white"
                            />
                            <div className="flex-1 min-w-0">
                                <p className="text-sm font-semibold truncate text-white">{user?.displayName || 'Nama Pengguna'}</p>
                                <p className="text-xs text-[#b5b3d6] truncate">{user?.email || 'email@pengguna.com'}</p>
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <button onClick={() => navigate('/pengaturan')} className="flex-1 py-2 rounded-lg bg-[#7963F5] hover:bg-[#9B8AF8] text-xs text-white font-semibold transition">Pengaturan</button>
                            <button onClick={logout} className="flex-1 py-2 rounded-lg bg-red-500/90 hover:bg-red-600 text-xs text-white font-semibold transition">Logout</button>
                        </div>
                    </div>
                </div>
            </aside>
            {/* Sidebar overlay hanya untuk lg ke atas */}
            {isSidebarOpen && (<div className="hidden lg:fixed lg:inset-0 lg:z-30 lg:bg-black/50" onClick={() => setIsSidebarOpen(false)}></div>)}
            <div className="lg:ml-64 flex flex-col h-screen">
                {/* Mobile header: ganti menu dengan notifikasi & profil */}
                <header className="sticky top-0 z-20 flex items-center justify-between p-4 bg-white dark:bg-gray-800 border-b dark:border-gray-700 lg:hidden">
                    <h1 className="text-lg font-semibold capitalize">{currentPage.replace('-', ' ')}</h1>
                    <div className="flex items-center gap-2">
                        <div className="relative">
                            <button className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700" onClick={() => setProfileDropdown(v => !v)}>
                                <img 
                                    src={user?.photoURL || `https://ui-avatars.com/api/?name=${user?.displayName || 'A'}&background=random&color=fff`} 
                                    alt="User Avatar"
                                    className="h-8 w-8 rounded-full object-cover border"
                                />
                            </button>
                            {profileDropdown && (
                                <div className="absolute right-0 mt-2 w-40 bg-white dark:bg-gray-800 rounded-lg shadow-lg py-2 z-50">
                                    <button onClick={() => { setProfileDropdown(false); navigate('/pengaturan'); }} className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700">Pengaturan</button>
                                    <button onClick={() => { setProfileDropdown(false); logout(); }} className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100 dark:hover:bg-gray-700">Logout</button>
                                </div>
                            )}
                        </div>
                    </div>
                </header>
                <main className="flex-1 overflow-y-auto p-4 sm:p-6 pb-20">
                    {children}
                    <Outlet />
                </main>
                {/* MobileNavbar dan MobileMenuOverlay tetap */}
                <MobileNavbar
                  currentPage={currentPage}
                  navigate={id => {
                    if (id === 'menu') setMobileMenuOpen(true);
                    else navigate(id.startsWith('/') ? id : '/' + id);
                  }}
                />
                <MobileMenuOverlay open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} navigate={id => navigate(id.startsWith('/') ? id : '/' + id)} />
            </div>
            {/* DesktopMenuOverlay */}
            {desktopMenuOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 animate-fade-in">
                    <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-3xl w-full mx-4">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-xl font-bold text-gray-800">Menu Utama</h2>
                            <button onClick={() => setDesktopMenuOpen(false)} className="p-2 rounded-full hover:bg-gray-100"><X className="h-6 w-6 text-gray-700" /></button>
                        </div>
                        <div className="grid grid-cols-3 gap-6">
                            {[
                                { id: 'dashboard', label: 'Dashboard', icon: Home, color: 'bg-green-400', iconColor: 'text-white' },
                                { id: 'absensi', label: 'Absensi', icon: ClipboardCheck, color: 'bg-purple-400', iconColor: 'text-white' },
                                { id: 'jadwal', label: 'Jadwal', icon: Calendar, color: 'bg-orange-400', iconColor: 'text-white' },
                                { id: 'jurnal', label: 'Jurnal', icon: BookText, color: 'bg-green-400', iconColor: 'text-white' },
                                { id: 'nilai', label: 'Nilai', icon: MinusSquare, color: 'bg-yellow-400', iconColor: 'text-white' },
                                { id: 'data-siswa', label: 'Siswa', icon: Users, color: 'bg-cyan-400', iconColor: 'text-white' },
                                { id: 'agenda', label: 'Agenda', icon: CalendarCheck, color: 'bg-red-400', iconColor: 'text-white' },
                                { id: 'laporan', label: 'Laporan', icon: FileText, color: 'bg-cyan-400', iconColor: 'text-white' },
                                { id: 'kalender-pendidikan', label: 'Kaldik', icon: MinusSquare, color: 'bg-purple-400', iconColor: 'text-white' },
                                { id: 'bantuan', label: 'Bantuan', icon: HelpCircle, color: 'bg-red-400', iconColor: 'text-white' },
                                { id: 'pengaturan', label: 'Pengaturan', icon: Settings, color: 'bg-cyan-300', iconColor: 'text-white' },
                            ].map(menu => (
                                <button
                                    key={menu.id}
                                    onClick={() => { setDesktopMenuOpen(false); navigate('/' + menu.id); }}
                                    className="flex flex-col items-center justify-center p-6 rounded-2xl bg-white shadow hover:shadow-lg transition group"
                                    style={{ minHeight: 140 }}
                                >
                                    <div className={`mb-3 w-14 h-14 flex items-center justify-center rounded-full ${menu.color} shadow-lg group-hover:scale-105 transition`}>
                                        <menu.icon className={`w-8 h-8 ${menu.iconColor}`} />
                                    </div>
                                    <span className="text-base font-semibold text-gray-800 group-hover:text-[#7963F5] transition">{menu.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AppLayout;